var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add_cloud_email_container"},[_c('addCloud',{class:_vm.$store.state.isLiteMode?'addDriveLiteMode':'',style:({height: (_vm.$store.state.isLiteMode ? 'calc(100% - 90px)' : 'calc(100% - 320px)')})}),_vm._v(" "),(!_vm.$store.state.isLiteMode)?_c('addEmail'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5806d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/add_cloud_email.vue
// module id = null
// module chunks = 